import {
  mapPaginationType,
  mapVenueShowType,
  useFindAllVenueShows,
} from '@api';
import {
  getTableParams,
  ManageTableProvider,
  useManageTable,
  VenueShowsTable,
} from '@common';
import { useTranslation } from 'react-i18next';
import { Route } from 'src/routes/_rootLayout/venues/$id.shows';

export const VenueConfirmedShows: React.FC = () => {
  const { id } = Route.useParams();
  const { t } = useTranslation('venueDetailsShows');

  const { tableIdConfirmed: tableId } = Route.useRouteContext();

  const searchParams = Route.useSearch();
  const tableParams = getTableParams(searchParams, tableId);

  const { data, isFetching } = useFindAllVenueShows(
    id,
    {
      type: 'CONFIRMED',
      ...tableParams,
    },
    {
      query: {
        select: (response) => ({
          shows: response.data.map(mapVenueShowType),
          pagination: mapPaginationType(response.metadata.pagination),
        }),
      },
    }
  );

  const shows = data?.shows ?? [];
  const pagination = data?.pagination ?? mapPaginationType(undefined);

  const methods = useManageTable({
    navigateFn: Route.useNavigate(),
    searchParams,
    pagination,
    config: {},
    tableId,
  });

  return (
    <ManageTableProvider {...methods}>
      <VenueShowsTable
        title={t('VENUE_CONFIRMED_SHOWS.TITLE')}
        shows={shows}
        isFetching={isFetching}
        dataTestId="venue-confirmed-shows-container"
      />
    </ManageTableProvider>
  );
};
